import {Routes} from '@angular/router';
import {AuthGuard} from '../app-core/security/auth.guard';
import {NotFoundComponent} from '../app-core/shared-pages/not-found/not-found.component';
import {LayoutComponent} from './layout/layout.component';
import {HomeComponent} from './modules/home/home.component';
import {LoginComponent} from './login/login.component';
import {PrivacyPolicyComponent} from '../app-core/shared-pages/privacy-policy/privacy-policy.component';


export const AppRoutes: Routes = [
    {
        path: "login", component: LoginComponent, canActivate: [AuthGuard]},
    {
        path: "privacidade", component: PrivacyPolicyComponent },
    {
        path: "",
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: "home",
                component: HomeComponent
            },
            {
                path: "sanitary-analysis",
                loadChildren: () => import('./modules/sanitary-analysis/sanitary-analysis-module')
                    .then(m => m.SanitaryAnalysisModule),
            },
            {
                path: "event-response",
                loadChildren: () => import('./modules/event-response/event-response.module')
                    .then((m)=>m.EventResponseModule)
            },
            {
                path: "user",
                loadChildren: () => import('../app-core/shared-pages/user/user.module')
                    .then((m)=>m.UserModule)
            },
            {
                path: "focus-actions",
                loadChildren: () => import('./modules/focus-actions/focus-actions.module')
                    .then((m)=>m.FocusActionsModule)
            },
            {
                path: "premise",
                loadChildren: () => import('./modules/premise/premise-module')
                    .then((m) => m.PremiseModule)
            },
            {
                path: "upload-movimentacoes",
                loadChildren: () => import('../app-core/shared-pages/upload-movimentacoes/upload-movimentacoes.module')
                    .then((m)=>m.UploadMovimentacoesModule)
            },
            {
                path: "async-tasks",
                loadChildren: () => import('../app-core/shared-pages/async-tasks/async-tasks.module')
                    .then((m)=>m.AsyncTasksModule)
            },
            {
                path: "forms",
                loadChildren: () => import('../app-core/shared-pages/planilhas/planilhas.module')
                    .then((m)=>m.PlanilhasModule)
            },
            {
                path: "spread-disease",
                loadChildren: () => import('./modules/spread-disease/spread-disease-module')
                    .then((m) => m.SpreadDiseaseModule)
            },
            {
                path: "**",
                redirectTo: "home",
            }
        ],
    },

    {path: "**", component: NotFoundComponent},
];
